import { useMutation } from '@tanstack/react-query';
import { POST, POST_WARRANTY_UPDATE } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';

export const onUploadFile = () =>
  useMutation({
    mutationFn: async (formData) => {
      const response = await POST(POST_WARRANTY_UPDATE(), formData);
      return response;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'แก้ไขข้อมูลสินค้าสำเร็จ' });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    onError: (response) => {
      openAlert({ model: 'message', type: 'error', message: response?.message });
    },
  });
